<script lang="ts" setup>
import { formatTime } from "@/utils/date";
import { IZeit } from "../api/useAuftrag";
import FahrzeitLoeschen from "../actions/FahrzeitLoeschen.vue";
import FahrzeitBearbeiten from "../actions/FahrzeitBearbeiten.vue";
import ZeitBox from "./ZeitBox.vue";

defineProps<{
  zeit: IZeit;
  query: () => void;
  blattId: string;
}>();
</script>

<template>
  <ZeitBox :datum="zeit.start.zeit" :bis="zeit.ende.zeit">
    <div class="flex justify-between">
      <div>
        {{ formatTime(zeit.start.zeit) }} -
        {{ formatTime(zeit.ende.zeit) }}
        <span class="text-xs">({{ zeit.stunden }}h)</span>
      </div>
      <div>
        {{ zeit.typ }}
      </div>
    </div>
    <div class="flex justify-between">
      <div>
        {{ zeit.bemerkung || "-" }}
      </div>
      <div class="flex space-x-2">
        <FahrzeitBearbeiten :query="query" :blatt-id="blattId" :zeit="zeit" />
        <FahrzeitLoeschen
          :query="query"
          :blatt-id="blattId"
          :zeit-id="zeit.id"
          :zeit-start="zeit.start.zeit"
          :zeit-ende="zeit.ende.zeit"
        />
      </div>
    </div>
    <div
      v-if="zeit.error"
      class="pt-2 pb-1 mt-2 text-sm font-medium text-red-600 whitespace-pre-line border-t-2 border-red-600 border-dashed"
    >
      {{ zeit.error }}
    </div>
  </ZeitBox>
</template>
